import * as React from "react";
import SearchBar from "./SearchBar";
import Option from "../model/Option";

interface SearchFieldSelectProps {
  placeholder: string;
  onSelect: (string) => void;
  options: Option[];
  icon?: string;
}

interface SearchFieldSelectState {
  hasFocus?: boolean;
  filter: string;
}

export default class SearchFieldSelect extends React.Component<
  SearchFieldSelectProps,
  SearchFieldSelectState
> {
  static defaultProps = {
    icon: "ic_search",
  };

  constructor(props: SearchFieldSelectProps) {
    super(props);
    this.state = {
      filter: "",
    };
  }

  render() {
    return (
      <div className="search-field-select group">
        <SearchBar
          placeholder={this.props.placeholder}
          onChange={(value) => this.setState({ filter: value })}
          onFocus={() => this.setState({ hasFocus: true })}
          onBlur={() => this.setState({ hasFocus: false })}
          value={this.state.filter}
          icon={this.props.icon}
        />
        {this.state.hasFocus && (
          <div className="options full-width">
            {this.props.options
              .filter(
                (option) =>
                  !this.state.filter ||
                  option.labelAsString.toLowerCase().indexOf(this.state.filter.toLowerCase()) > -1
              )
              .sort(Option.byName)
              .map((option) => (
                <div
                  key={option.value}
                  className="clickable"
                  onMouseDown={() => this.onSelect(option.value)}
                >
                  {option.label}
                </div>
              ))}
          </div>
        )}
      </div>
    );
  }

  private onSelect(selectedValue) {
    this.setState({ filter: "" });
    this.props.onSelect(selectedValue);
  }
}
